import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import { CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';

import './index.scss';
import { uploadContentService } from '../../../services';

import { useHistory } from 'react-router-dom';
import PresentationsModal from '../Modals/ManagePresentationModal';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#252525",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        color: theme.palette.common.white,
    },
    button: {
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#424242",
        },
        '&:nth-of-type(even)': {
            backgroundColor: "#252525",
        },
    },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
    return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles({
    table: {
        maxWidth: 2000
    },
    button: {
        marginTop: 10,
        height: 40,
        width: 200,
        fontSize: 15,
        fontWeight: 'bold',
        color: '#ffffff',
        backgroundColor: '#6C6C6C'
    },
    buttonFloatRight: {
        marginTop: 10,
        height: 40,
        width: 200,
        fontSize: 15,
        fontWeight: 'bold',
        color: '#ffffff',
        backgroundColor: '#6C6C6C',
        float: 'right'
    }
});

export default function PresentationsTable() {
    const classes = useStyles();
    const history = useHistory();

    const [presentations, setPresentations] = useState([]);
    const { user } = useSelector(state => state.userAuthentication);
    const [isPresentationsModalShow, setIsPresentationsModalShow] = useState(false);
    const [modalInfo, setModalInfo] = useState({
        id: undefined,
        modalType: 'add',
        editInfo: undefined
    });

    const handleClickPresentations = async (id = undefined, modalType = 'add', editInfo = undefined) => {
        setIsPresentationsModalShow(true);
        setModalInfo({
            id: id,
            modalType: modalType,
            editInfo: editInfo
        });
    }

    const handleAddPresentation = async (event) => {
        if (event.currentTarget.dataset.value === "addPresentations") {
            // await uploadContentService.uploadSendPlaylistToDevice(user, parseInt(event.currentTarget.dataset.id))
        }
    }

    const handleEditPresentation = async (event) => {
        if (event.currentTarget.dataset.value === "editPresentations") {
            // await uploadContentService.uploadSendPlaylistToDevice(user, parseInt(event.currentTarget.dataset.id))
        }
    }

    const getPresentations = useCallback(async () => {
        if (!isUndefined(user)) {
            const res = await uploadContentService.getPresentations(user);
            setPresentations(res);
        }
    }, [user]);

    useEffect(() => {
        getPresentations();
    }, [getPresentations]);

    return (
        <div style={{ marginBottom: '30px' }}>
            <span className="span-design">
                <div className="icon-design"><WifiTetheringIcon /> PRESENTATIONS </div>
                <h3 className="text-design">  CONTENT </h3>
            </span>
            <TableContainer component={Paper} className={classes.table}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">PRESENTATIONS LIST</StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableCell>
                                <Button
                                    onClick={handleClickPresentations}
                                    variant="contained"
                                    data-value="addPresentations"
                                    className={classes.button}
                                >
                                    ADD PRESENTATION
                                </Button>
                            </StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isUndefined(presentations) ? (
                            [...presentations].map(item => (
                                <StyledTableRow key={item.name} >
                                    <StyledTableCell align="left">{item.name}</StyledTableCell>
                                    <StyledTableCell align="left">
                                        <Button
                                            onClick={() => {
                                                handleClickPresentations(item.id, 'edit', item);
                                            }}
                                            variant="contained"
                                            data-value="editPresentations"
                                            data-id={item.id}
                                            className={classes.buttonFloatRight}
                                        >
                                            EDIT
                                        </Button>
                                    </StyledTableCell>

                                </StyledTableRow>
                            ))
                        ) : (
                            <div className="loader">
                                <CircularProgress />
                            </div>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {isPresentationsModalShow ? (<PresentationsModal modalShow={isPresentationsModalShow} 
            modalState={setIsPresentationsModalShow} 
            id={modalInfo.id} modalType={modalInfo.modalType}
            editInfo={modalInfo.editInfo} />) : ''}
        </div>
    );
}